import { Navbar } from './sections/Navbar';
import { Hero } from './sections/Hero';
import { TrustBar } from './sections/TrustBar';
import { Services } from './sections/Services';
import { Prices } from './sections/Prices';
import { StudentPromo } from './sections/StudentPromo';
import { Gallery } from './sections/Gallery';
import { Reviews } from './sections/Reviews';
import { About } from './sections/About';
import { FindUs } from './sections/FindUs';
import { Footer } from './sections/Footer';
import { MobileActionBar } from './sections/MobileActionBar';

const Home = () => (
  <div className="min-h-screen bg-ink text-white font-sans pb-16 lg:pb-0">
    <Navbar />
    <Hero />
    <TrustBar />
    <Services />
    <Prices />
    <StudentPromo />
    <Gallery />
    <Reviews />
    <About />
    <FindUs />
    <Footer />
    <MobileActionBar />
  </div>
);

export default Home;
